import Vue from "vue";
import VueCookies from "vue-cookies";
import store from "@/store";

Vue.use(VueCookies);

export function setAccesToken(state, token) {
  Vue.$cookies.set("token", token);
  state.access_token = token;
}

export function setRefreshToken(state, token) {
  Vue.$cookies.set("refresh", token);
  state.refresh_token = token;
}

export function setUserIsLogged(state, value) {
  Vue.$cookies.set("userIsLogged", value);
  state.isLogged = value;
}

export function setUserData(state, data) {
  Vue.$cookies.set("userId", data["id"]);
  Vue.$cookies.set("userName", `${data["name"]}`);
  Vue.$cookies.set("unique", data["user"]["id"]);
  
  if (state.type != "parent") {
    if (data["originalParentId"]){
      Vue.$cookies.set("originalParentId",data["originalParentId"]);
    }    
    Vue.$cookies.set("parentName", data["parent"]["name"]);
    Vue.$cookies.set("parentId", data["parent"]["id"]);
    //Vue.$cookies.set("childFirstTime", data.moduleFocusOn == null);
    //state.childFirstTime = data.moduleFocusOn == null;
    //data["score"] = data["stars"];
  } else {
    Vue.$cookies.set("originalParentId",0);
    data["score"] = data["total_points"];
    data["stars"] = data["total_points"];
    data["availablePoints"] = data["available_points"];
    
    // eslint-disable-next-line no-self-assign
    data["level"] = data["level"];
  }
  state.userData = data;
}

export function setchildrenIds(state, ids) {
  state.hasChildren = true;
  state.childrenIds = ids;
}

export function logout(state) {
  Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie));
  state.access_token = "";
  state.refresh_token = "";
  state.userData = {};
  state.type = "";
  state.hasChildren = false;
  state.childrenIds = [];
  state.childrenData = [];
  state.childSelectedId = "";
  state.childSelectedName = "";
  state.ChildselectedEmail = "";
  state.childrenCounter = 0;
  state.isLogged = false;
  state.error = false;
  state.errorMessage = "";
  state.childDataGetted = false;
  state.genders = [];
  state.childFirstTime = true;
  state.notificationSetup = [];
}

export function setChildrenData(state, data) {
  state.childrenData = data;
  Vue.$cookies.set("childCount", data.length);
  state.childrenCounter = data.length;
}

export function registerError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
}

export function cleanErrors(state) {
  state.error = false;
  state.errorMessage = "";
}

export function setChildrenSelectedId (state, childId) {
  // Vue.$cookies.set("childSelectedId", childId);
  localStorage.setItem('rewardChildId', childId);
  state.childSelectedId = childId
}

export function setChildSelectedData(state, payload) {
  Vue.$cookies.set("childSelectedId", payload.id);
  Vue.$cookies.set("childSelectedName", payload.name);
  Vue.$cookies.set("theme", payload.themeSelection);
  state.theme = payload.themeSelection;
  state.childSelectedId = payload.id;
  state.childSelectedName = payload.name;
}

export function markUniqueChildAsSelected(state) {
  Vue.$cookies.set("childSelectedId", state.childrenData[0].id);
  Vue.$cookies.set("childSelectedName", state.childrenData[0].name);
  Vue.$cookies.set("theme", state.childrenData[0].themeSelection);
  state.theme = state.childrenData[0].themeSelection;
  state.childSelectedId = state.childrenData[0].id;
  state.childSelectedName = state.childrenData[0].name;
}

export function setUserType(state, type) {
  store.commit("general/setIsCharging", true);
  Vue.$cookies.set("userType", type);
  state.type = type;
}

export function saveGenders(state, payload) {
  state.genders = payload;
}

export function incrementChildCount(state) {
  var length = parseInt(Vue.$cookies.get("childCount"));
  Vue.$cookies.set("childCount", length + 1);
  state.childrenCounter = length + 1;
}

export function childFirstTimeComplete(state) {
  Vue.$cookies.set("childFirstTime", false);
  state.childFirstTime = false;
}

export function saveNotificationSetup(state, data) {
  state.notificationSetup = data;
}

export function themeChange(state, data) {
  Vue.$cookies.set("theme", data);
  state.theme = data;
}

export function error(state, error) {
  console.log("errorcatrche", error);
  state.error = true;
  state.errorMessage = error;
}

export function UpdateUserName(state, data) {
  Vue.$cookies.set("userName", data.name);
  state.userData["name"] = data.name;
  state.userData["last_name"] = data.last_name;
  state.userData["birthdate"] = data.birthdate;
}

export function updateNotifications(state, data) {
  state.notifications = data;
}

export function saveChildProfile(state, data) {
  let aux = state.childProfile;
  state.childProfile = {};
  state.childProfile = aux;
  state.childProfile[data.id] = data;
}

export function setTimeZoneList(state, value) {
  state.timeZoneList = value;
}

export function SetTimeZone(state, value) {
  state.timeZone = value;
}

export function saveChildAvatar(state, data) {
  if (data.avatar) {
    state.childAvatar = data.avatar;
  } else {
    state.childAvatar = "";
  }
}
